export const BASE_URL = "https://pharmajobshirelink.com/hirelink_apis/";